<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header card-gis-filter">
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="1">
            <div class="row p-3">
              <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                <label>{{ $t('common_words.farm') }} *</label>
                <br />
                <el-select
                  @clear="boxReportForm.farms = []"
                  clearable
                  multiple
                  :multiple-limit="1"
                  v-bind:collapse-tags="true"
                  filterable
                  class="select-primary custom-width-select required-farm shadow-sm"
                  size="large"
                  v-model="boxReportForm.farms"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="(option, index) in farms"
                    class="select-primary"
                    :value="option.id"
                    :label="option.name"
                    :key="index + option.id"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                <label>{{ $t('common_words.analyze_by') }} </label>
                <br />
                <el-select
                  @change="changeByInterval"
                  filterable
                  @clear="boxReportForm.bySel = null"
                  clearable
                  class="select-primary custom-width-select required-farm shadow-sm"
                  size="large"
                  v-model="boxReportForm.bySel"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="option in optionsInterval"
                    class="select-primary"
                    :value="option.value"
                    :label="option.label"
                    :key="option.value"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-12 col-sm-8 col-md-4 col-lg-4 col-xl-3"
                v-if="
                  boxReportForm.bySel &&
                  boxReportForm.bySel != 'week' &&
                  boxReportForm.bySel != 'year'
                "
              >
                <label>{{ $t('common_words.calendar') }}</label>
                <br />
                <el-date-picker
                  v-if="renderComponent"
                  v-model="rangeDate"
                  clearable
                  class="shadow-sm required-year"
                  v-bind:type="typedatepicket"
                  :picker-options="pickerOptions"
                  range-separator="-"
                  :placeholder="`${$t('common_words.select2')}...`"
                  :start-placeholder="$t('common_words.initial_date')"
                  :end-placeholder="$t('common_words.final_date')"
                >
                </el-date-picker>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                style="padding-right: 0; padding-top: 32px"
                v-if="
                  boxReportForm.bySel == 'week' || boxReportForm.bySel == 'year'
                "
              >
                <el-select
                  clearable
                  @clear="boxReportForm.week_sel_init = null"
                  filterable
                  class="select-primary custom-width-select required-year shadow-sm"
                  size="large"
                  v-model="boxReportForm.year_sel_init"
                >
                  <el-option
                    v-for="(option, index) in Object.keys(years).reverse()"
                    class="select-primary"
                    :value="option"
                    :label="option"
                    :key="index * 100 + 1"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                style="padding-top: 32px"
                v-if="
                  boxReportForm.bySel == 'week' && boxReportForm.year_sel_init
                "
              >
                <el-select
                  clearable
                  filterable
                  class="select-primary custom-width-select required-week shadow-sm"
                  size="large"
                  v-model="boxReportForm.week_sel_init"
                >
                  <el-option
                    v-for="(week, index) in years[boxReportForm.year_sel_init]"
                    class="select-primary"
                    :value="week"
                    :label="week"
                    :key="index * 200 + 2"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                style="padding-right: 0; padding-top: 32px"
                v-if="
                  boxReportForm.bySel == 'week' || boxReportForm.bySel == 'year'
                "
              >
                <el-select
                  clearable
                  @clear="boxReportForm.week_sel_end = null"
                  filterable
                  class="select-primary custom-width-select required-year shadow-sm"
                  size="large"
                  v-model="boxReportForm.year_sel_end"
                >
                  <el-option
                    v-for="(option, index) in Object.keys(years).reverse()"
                    class="select-primary"
                    :value="option"
                    :label="option"
                    :key="index * 300 + 4"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                style="padding-top: 32px"
                v-if="
                  boxReportForm.bySel == 'week' && boxReportForm.year_sel_end
                "
              >
                <el-select
                  clearable
                  filterable
                  class="select-primary custom-width-select required-week shadow-sm"
                  size="large"
                  v-model="boxReportForm.week_sel_end"
                >
                  <el-option
                    v-for="(week, index) in years[boxReportForm.year_sel_end]"
                    class="select-primary"
                    :value="week"
                    :label="week"
                    :key="index * 400 + 6"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-12 col-md-4 col-xl-2">
                <label class="label-primary" style="color: transparent">{{
                  $t('common_words.filter')
                }}</label
                ><br />
                <l-button wide type="info" class="btn-filter" @click="validate">
                  {{ $t('common_words.filter') }}
                </l-button>
              </div>
            </div>
            <br />
          </el-collapse-item>
        </el-collapse>
      </card>
      <br />
      <template v-if="boxReport">
        <card class="custom-shadow-card-header">
          <div
            v-if="
              Object.keys(chartOptions1).length > 0 &&
              Object.values(chartOptions1.xAxis.categories).length
            "
          >
            <div class="row">
              <div
                class="col-sm-12 col-md-12 changeChart none 1"
                style="display: inline-flex"
              >
                <div
                  class="col-sm-1 col-md-1 cursors"
                  @click="chartOptions1 = columns(chartsData.column_chart)"
                >
                  <em class="fa fa-bar-chart" aria-hidden="true"></em>
                </div>
                <div
                  class="col-sm-1 col-md-1 cursors"
                  @click="chartOptions1 = lines(chartsData.column_chart)"
                >
                  <em class="fa fa-line-chart" aria-hidden="true"></em>
                </div>
              </div>
              <div class="col-12">
                <highcharts :options="chartOptions1"></highcharts>
              </div>
            </div>
          </div>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('common_words.selected_record_no_graph') }}
            </h5>
          </div>
        </card>
        <br />
        <card class="custom-shadow-card-header">
          <div v-if="Object.keys(chartOptions2).length > 0">
            <div class="row">
              <div class="col-12">
                <highcharts :options="chartOptions2"></highcharts>
              </div>
            </div>
          </div>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('common_words.selected_record_no_graph') }}
            </h5>
          </div>
        </card>
        <br />
        <card class="custom-shadow-card-header">
          <div v-if="isIndex()">
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                clearable
                @clear="pagination.perPage = 10"
                class="select-default mb-3 shadow-sm"
                style="width: 200px"
                v-model="pagination.perPage"
                :placeholder="$t('common_words.per_page')"
                filterable
              >
                <el-option
                  class="select-default"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
              <el-input
                clearable
                class="mb-3 shadow-sm"
                style="width: 200px"
                :placeholder="$t('common_words.search_records')"
                v-model="searchQuery"
                aria-controls="datatables"
              />
            </div>
            <div class="col-sm-12">
              <el-table
                stripe
                :default-sort="{ prop: 'name', order: 'descending' }"
                :data="queriedData"
                max-height="500"
                style="width: 100%"
                :border="true"
                show-summary
                :summary-method="getSummariesAndOneAVG"
              >
                <el-table-column
                  prop="code"
                  :label="$t('common_words.code')"
                  min-width="150"
                  :sortable="true"
                  :resizable="false"
                  :align="'center'"
                ></el-table-column>
                <el-table-column
                  prop="name"
                  :label="$t('production.box')"
                  min-width="150"
                  :sortable="true"
                  :resizable="false"
                  :align="'center'"
                ></el-table-column>
                <el-table-column
                  prop="range"
                  :label="$t('samples.range')"
                  min-width="150"
                  :sortable="true"
                  :resizable="false"
                  :align="'center'"
                ></el-table-column>
                <el-table-column
                  :label="$t('production.boxes_number')"
                  min-width="200"
                >
                  <el-table-column
                    v-for="column in tableColumns"
                    :key="column.label"
                    :min-width="column.minWidth"
                    :prop="column.prop"
                    :label="column.label"
                    :formatter="formatNumberTable"
                    :fixed="column.fixed"
                    :sortable="column.sortable"
                    :align="column.align"
                    :resizable="false"
                  >
                  </el-table-column>
                </el-table-column>
                <el-table-column
                  :label="$t('production.sum_symbol')"
                  min-width="200"
                >
                  <el-table-column
                    v-for="column in tableColumns2"
                    :key="column.label"
                    :min-width="column.minWidth"
                    :prop="column.prop"
                    :label="column.label"
                    :formatter="formatNumberTable"
                    :fixed="column.fixed"
                    :sortable="column.sortable"
                    :align="column.align"
                    :resizable="false"
                  >
                  </el-table-column>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('common_words.no_permissions') }}
            </h5>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class>
              <p class="card-category">
                {{ $t('table2.showing') }} {{ from + 1 }} {{ $t('table2.a') }}
                {{ to }} {{ $t('table2.of') }} {{ total }}
                {{ $t('table2.entries') }}
              </p>
            </div>
            <l-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
              pageFirst="false"
              pageLast="false"
            ></l-pagination>
          </div>
        </card>
        <div class="row" style="padding-right: 13px; padding-left: 13px">
          <div class="col-6" v-if="isPDF()">
            <div class="text-right">
              <button
                class="btn btn-danger custom-shadow-btn"
                @click="exportPDF"
              >
                <em class="fa fa-file-pdf-o"></em>
                {{ $t('common_words.export_to_pdf') }}
              </button>
            </div>
          </div>
          <div class="col-6" v-if="isExcel()">
            <div class="text-left">
              <button
                class="btn custom-btn-success custom-shadow-btn"
                @click="exportExcel"
              >
                <em class="fa fa-file-excel-o"></em>
                {{ $t('common_words.export_to_excel') }}
              </button>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { Chart } from 'highcharts-vue';
import { MixinExport } from 'src/mixins/mixin-export';
import exportingInit from 'highcharts/modules/exporting';
import Formatter from 'src/class/Formatter';
import Highcharts from 'highcharts';
import mixinCharts from 'src/util/mixinCharts';
import MixinDatePicker from 'src/util/mixinDatePicker';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';
import configTable from './boxReportTable1';
import configTable2 from './boxReportTable2';
import i18n from 'src/i18n';

exportingInit(Highcharts);

export default {
  components: {
    highcharts: Chart,
  },

  computed: {
    ...configTable().Search,
    ...configTable2().Search,
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
    optionsInterval() {
      return {
        0: { label: i18n.t('common_words.day'), value: 'daterange' },
        1: { label: i18n.t('common_words.week'), value: 'week' },
        2: { label: i18n.t('common_words.month'), value: 'monthrange' },
        3: { label: i18n.t('common_words.year'), value: 'year' },
      };
    },
  },

  data() {
    return {
      boxReportForm: {
        bySel: null,
      },
      chartOptions1: {},
      chartOptions2: {},
      activeName: '1',
      typedatepicket: 'daterange',
      valueCollapse: null,
      reports: [],
      interval: 'Semana',
      years: [],
      farms: [],
      boxReport: false,
      titleCard: '',
      pagination: {},
      flag: null,
      tableColumns: [],
      tableColumns2: [],
      chartsData: [],
    };
  },

  mixins: [
    mixinMasters,
    MixinPermissions,
    MixinDatePicker,
    mixinCharts,
    MixinExport,
    MixinMenu,
  ],

  watch: {
    '$i18n.locale': ['setupTable', 'setupTable2', 'forceRerender'],
  },

  methods: {
    changeByInterval() {
      this.boxReport = false;
      for (
        let index = 0;
        index < Object.values(this.optionsInterval).length;
        index++
      ) {
        const element = Object.values(this.optionsInterval)[index];
        if (element.label == this.boxReportForm.bySel) {
          this.typedatepicket = element.value;
          break;
        }
      }
    },

    handleCollapse(val) {
      this.valueCollapse = val;
    },

    validate() {
      this.boxReportForm.calendar_sel = this.rangeDate;

      if (
        this.boxReportForm.farms == null ||
        this.boxReportForm.farms.length == 0
      ) {
        return this.validationInputsRequired('farm');
      } else if (
        (this.boxReportForm.bySel == 'year' &&
          (this.boxReportForm.year_sel_init == null ||
            this.boxReportForm.year_sel_end == null)) ||
        (this.boxReportForm.bySel == 'week' &&
          this.isYearSelRequired() &&
          this.boxReportForm.year_sel_init == null)
      ) {
        return this.validationInputsRequired('year');
      } else if (
        this.isWeekSekRequired() &&
        this.boxReportForm.week_sel_init == null &&
        this.boxReportForm.bySel == 'week'
      ) {
        return this.validationInputsRequired('week');
      } else if (
        this.isYearSelRequired() &&
        this.boxReportForm.year_sel_end == null &&
        this.boxReportForm.bySel == 'week'
      ) {
        return this.validationInputsRequired('year');
      } else if (
        this.isWeekSekRequired() &&
        this.boxReportForm.week_sel_end == null &&
        this.boxReportForm.bySel == 'week'
      ) {
        return this.validationInputsRequired('week');
      } else if (this.boxReportForm.calendar_sel == null) {
        SweetAlert.warning(i18n.t('common_words.calendar'));
      } else {
        this.chartOptions1 = {};
        this.chartOptions2 = {};
        this.loadBoxReport();
      }
    },

    formatNumberTable(row, column) {
      return typeof row[column.property] === 'string' ||
        row[column.property] instanceof String
        ? row[column.property]
        : Formatter.formatMoney(row[column.property], 3);
    },

    calculateTotalRow(row, index) {
      let total = 0;

      for (const key in row) {
        if (key != 'type' && key != 'bysel') {
          total += row[key];
        }
      }

      this.totals[index] = total;

      return total;
    },

    calculateTotalColumn(column) {
      let total = 0;

      if (column != 'all') {
        this.table_data.forEach((row) => {
          if (row[column]) {
            total += row[column];
          }
        });
      } else {
        this.totals.forEach((elem) => {
          total += elem;
        });
      }

      return total;
    },

    loadData() {
      let data = {
        farms: this.boxReportForm.farms,
        init:
          parseInt(this.boxReportForm.year_sel_init) * 100 +
          parseInt(this.boxReportForm.week_sel_init),
        end:
          parseInt(this.boxReportForm.year_sel_end) * 100 +
          parseInt(this.boxReportForm.week_sel_end),
        bySel: this.boxReportForm.bySel,
      };

      switch (this.boxReportForm.bySel) {
        case 'year':
          data.init = parseInt(this.boxReportForm.year_sel_init);
          data.end = parseInt(this.boxReportForm.year_sel_end);
          break;
        case 'monthrange':
          data.init = parseInt(moment(this.rangeDate[0]).format('MM'));
          data.end = parseInt(moment(this.rangeDate[1]).format('MM'));
          break;
        case 'daterange':
          data.init = moment(this.rangeDate[0]).format('YYYY-MM-DD');
          data.end = moment(this.rangeDate[1]).format('YYYY-MM-DD');
          break;
      }

      return data;
    },
    setRingingsReport() {
      if (this.flag) {
        this.flag;
        this.titleCard =
          this.boxReportForm.type == 0
            ? i18n.t('common_words.consolidated_ringing_report')
            : i18n.t('common_words.detailed_ringing_report');
      }
    },

    loadBoxReport() {
      this.showHideLoading(true);
      let data = this.loadData();
      data.route = 'scales/boxes/reports';

      Axios.saveMaster(data)
        .then((response) => {
          if (response.data) {
            this.chartsData = response.data;
            this.flag = response.data;
            try {
              this.setRingingsReport();
            } catch (error) {
              console.log('error: ', error);
            }
            this.tableData = this.chartsData.table_data;

            let table_full = ['code', 'name', 'range'];
            table_full.concat(
              this.tableColumns.map((prop) => {
                return prop.prop;
              })
            );
            table_full.concat(
              this.tableColumns2.map((prop) => {
                return prop.prop;
              })
            );

            this.searchFuse(table_full);
            this.chartOptions1 = this.columns(this.chartsData.column_chart);
            this.chartOptions2 = this.pieChart(
              this.chartsData.pie_chart,
              null,
              true
            );

            this.boxReport = true;
          }

          this.showHideLoading();
        })
        .catch((error) => {
          console.log(error);
          this.showHideLoading();
        });
    },

    isYearSelRequired() {
      return this.interval == 'Semana';
    },

    isWeekSekRequired() {
      return this.interval == 'Semana';
    },

    exportPDF() {
      let data = this.loadData();
      data.route = 'scales/boxes/reports/pdf';
      data.name_file = `${i18n.t('production.boxes_report')}.pdf`;

      this.PDF(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    exportExcel() {
      let data = this.loadData();
      data.route = 'scales/boxes/reports/excel';
      data.name_file = `${i18n.t('production.boxes_report')}.xlsx`;

      this.Excel(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },
    setupTable() {
      const { Table } = configTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
    setupTable2() {
      const { Table } = configTable2();
      this.tableColumns2 = Table.tableColumns2;
      this.pagination = { ...Table.pagination };
    },
  },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.setupTable2();
      this.showHideLoading(true);
      Axios.getMasters('farms/farms/onlyfruit')
        .then((response) => {
          Axios.getMasters('calendars/getyearsbusiness')
            .then((response1) => {
              this.farms = response.data.data;
              this.years = response1.data;
              this.showHideLoading();
            })
            .catch((error) => this.showMessageErrors(error));
        })
        .catch((error) => this.showMessageErrors(error));
    } else {
      this.showHideLoading();
    }

    let current = new Date();
    this.rangeDate = [
      new Date(current.setDate(current.getDate() - current.getDay())),
      new Date(current.setDate(current.getDate() - current.getDay() + 6)),
    ];
  },

  mounted() {
    this.selectedItemOnMenu('scales');
  },

  destroyed() {
    this.deselectedItemOnMenu('scales');
  },
};
</script>
<style></style>
